// src/styles.js
// Global CSS injected as a <style> tag in App.

export const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700&family=Barlow+Condensed:wght@600;700&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
  :root{
    --cream:#f2f2f2;
    --warm1:#e8e8e8;
    --warm2:#cccccc;
    --warm3:#999999;
    --brown:#111111;
    --dark:#111111;
    --text:#1a1a1a;
    --muted:#555555;
    --green:#1a7a3a;
    --red:#b01020;
    --blue:#444444;
    --sh:0 2px 16px rgba(0,0,0,.10);
    --sh-lg:0 8px 40px rgba(0,0,0,.18);
  }
  body{background:var(--cream);font-family:"Barlow",sans-serif;color:var(--text);}
  h1,h2,h3,h4{font-family:"Barlow Condensed",sans-serif;letter-spacing:.3px;}
  @keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  input,textarea,select{font-family:"Barlow",sans-serif;}
  ::-webkit-scrollbar{width:5px;height:5px;}
  ::-webkit-scrollbar-track{background:var(--warm1);}
  ::-webkit-scrollbar-thumb{background:var(--warm3);border-radius:3px;}
  .mobile-nav{display:none;}
  .mobile-menu-btn{display:none;}
  .mobile-backdrop{display:none;}
  .pipe-scroll{scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:thin;}
  .pipe-scroll > div{scroll-snap-align:start;}
  .pipe-wrap{position:relative;}
  .pipe-wrap::after{content:"";position:absolute;top:0;right:0;width:24px;height:100%;background:linear-gradient(to right,transparent,rgba(0,0,0,.05));pointer-events:none;border-top-right-radius:14px;border-bottom-right-radius:14px;}
  @media(max-width:768px){
    /* Hamburger button -- top-left of screen on mobile, opens the drawer */
    .mobile-menu-btn{display:flex!important;position:fixed;top:12px;left:12px;z-index:90;width:44px;height:44px;border-radius:10px;background:#1a1a1a;color:#fff;border:none;align-items:center;justify-content:center;font-size:22px;cursor:pointer;box-shadow:0 2px 12px rgba(0,0,0,.25);}
    /* Sidebar becomes a fixed off-screen drawer; slides in when data-open */
    .desk-sb{display:flex!important;position:fixed!important;top:0;left:0;height:100vh;z-index:200;width:280px!important;transform:translateX(-100%);transition:transform .25s ease;}
    .desk-sb[data-open="true"]{transform:translateX(0);}
    /* Dark backdrop behind the drawer */
    .mobile-backdrop[data-open="true"]{display:block;position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:150;}
    /* Bottom tab nav still visible for quick tab switching */
    .mobile-nav{display:flex;position:fixed;bottom:0;left:0;right:0;background:#fff;border-top:1px solid var(--warm2);z-index:100;padding:6px 0 max(6px,env(safe-area-inset-bottom));}
    .main-pad{padding:16px!important;padding-top:64px!important;padding-bottom:80px!important;}
    .g2{grid-template-columns:1fr!important;}
    .pipe-scroll > div{min-width:280px!important;flex:0 0 280px!important;}
    .route-grid{grid-template-columns:1fr!important;}
    .route-dest{grid-template-columns:1fr 1fr!important;}
    .route-dest > *:first-child,.route-dest > *:last-child{grid-column:1 / -1;}
  }
`;
